import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { WBBox, WBFlex, WBTypography, WBLinkButton } from '@admiin-com/ds-web';
import { styled, useTheme } from '@mui/material';
import { CurrencyNumber } from '../../CurrencyNumber/CurrencyNumber';
import { DocumentAnalysisLineItemInput, TaxType } from '@admiin-com/ds-graphql';
import DocumentAnalysisInputTable from './DocumentAnalysisInputTable';

interface Props {
  lineItems: DocumentAnalysisLineItemInput[];
  setLineItems: (lineItems: DocumentAnalysisLineItemInput[]) => void;
  defaultGST?: TaxType;

  hasServiceLookup?: boolean;
  fromEntityId?: string;
}
export function BillLineItems({
  lineItems,
  setLineItems,
  defaultGST,
  hasServiceLookup,
  fromEntityId,
}: Props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const total = React.useMemo(
    () =>
      lineItems?.reduce(
        (totalPrice, lineItem) =>
          totalPrice + (lineItem.price ? lineItem.price : 0),
        0
      ) ?? 0,
    [lineItems]
  );
  const removeLineItems = () => {
    setLineItems([]);
  };

  return (
    <Content>
      <DocumentAnalysisInputTable
        setRows={setLineItems}
        rows={lineItems}
        defaultGST={defaultGST}
        hasServiceLookup={hasServiceLookup}
        fromEntityId={fromEntityId}
      />
      <FooterContainer>
        <WBBox width={['100%', 200]}>
          <FooterRow>
            <WBTypography fontWeight={'bold'}>
              {t('totalDue', { ns: 'taskbox' })}
            </WBTypography>
            <CurrencyNumber
              mb={0}
              variant="h5"
              number={total}
              sup={false}
              fontWeight={'bold'}
            />
          </FooterRow>
        </WBBox>
      </FooterContainer>
      <WBLinkButton
        noDecoration
        color={theme.palette.primary.main}
        sx={{ ':hover': { color: theme.palette.error.main } }}
        onClick={removeLineItems}
      >
        {t('removeLineItems', { ns: 'taskbox' })}
      </WBLinkButton>
    </Content>
  );
}
const Content = styled(WBBox)(({ theme }) => ({
  width: '100%',
}));
const FooterRow = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));
const FooterContainer = styled(WBFlex)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.text.secondary}`,
  borderBottom: `1px solid ${theme.palette.text.secondary}`,
  flexDirection: 'column',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  width: '100%',
  alignItems: 'end',
  [theme.breakpoints.down('sm')]: {
    alignItems: 'start',
  },
}));
